import {Component, Input, OnInit} from '@angular/core';
import {AllegatoService} from 'src/app/service/allegato.service';
import {Allegato} from 'src/app/model/allegato';
import {ContenutoGenericoService} from 'src/app/service/contenuto-generico.service';
import {ContenutoGenerico} from 'src/app/model/contenuto-generico';
import {Search} from 'src/app/common/search';
import {DOCS_REPLACE} from '../../constants/constants';

@Component({
    selector: 'app-banners',
    templateUrl: './banners.component.html',
})
export class BannersComponent implements OnInit {

    @Input() element: ContenutoGenerico;
    @Input() posizione: string;
    @Input() c_style: number;

    banner: ContenutoGenerico;

    public allegato: Allegato;
    hasContainer: boolean;
    lingua: string;
    loading = true;

    constructor(private contenutoService: ContenutoGenericoService,
                private allegatoService: AllegatoService) {
    }

    ngOnInit() {
        this.lingua = this.element.lang;
        this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
        this.contenutoService.search._limit = 1;
        this.contenutoService.search._start = 0;
        this.contenutoService.search._contains.pagina = this.element.uuid;
        this.contenutoService.search._.posizione = this.posizione;
        this.contenutoService.search._.lang = this.lingua;
        this.contenutoService.getList().subscribe(banners => {
                for (const banner of banners) {
                    this.banner = banner;
                    if (this.banner.contenitore) {
                        this.hasContainer = true;
                    } else {
                        this.hasContainer = false;
                    }
                    this.allegatoService.find(this.banner.immagine).subscribe(allegato => {
                            this.allegato = allegato;
                            if (allegato != null) {
                                this.allegato.path = DOCS_REPLACE(this.allegato.uuid);
                            }
                            this.loading = false;
                            this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
                        },
                        err => {
                            this.loading = false;
                            this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
                        });
                }
            },
            err => {
                this.loading = false;
                this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
            });
    }

}
